import { sectionIDs } from '../../../constants/section-ids.constants';

interface BiographyViewProps {
  username: string;
}

export const BiographyView = (props: BiographyViewProps) => {
  const { username } = props;
  return (
    <section id={sectionIDs.BIOGRAPHY_VIEW}>
      <p>Bio for username: {username}</p>
    </section>
  );
};
